<!-- @format -->

<ng-container *transloco="let t">
  @if (questionnaire$ | async; as questionnaire) {
    @if (answers$ | async; as answers) {
      <sis-description-list [columnCount]="1">
        @for (question of questionnaire.enrolmentQuestions; track entityId($index, question)) {
          @if (question.questionType === "LANGUAGE_SELECT") {
            <dl>
              <ng-template #listItem>
                <dt>{{ t("ENROLMENT_QUESTIONAIRE_LANG_ANSWER_TITLE") }}</dt>
                <dd>{{ (getAnswerByQuestionId(answers, question.localId)?.selections[0] | codeLocalizedName | async) || "-" }}</dd>
              </ng-template>
            </dl>
          }
          @if (question.questionType === "FREE_TEXT") {
            <dl>
              <ng-template #listItem>
                <dt>{{ question.question | localizedString }}</dt>
                <dd>{{ getAnswerByQuestionId(answers, question.localId)?.answerText || "-" }}</dd>
              </ng-template>
            </dl>
          }
        }
      </sis-description-list>
    }
  }
</ng-container>
